import { render, staticRenderFns } from "./EditManufacturers.vue?vue&type=template&id=389bc700&scoped=true&"
import script from "./EditManufacturers.vue?vue&type=script&lang=js&"
export * from "./EditManufacturers.vue?vue&type=script&lang=js&"
import style0 from "./EditManufacturers.vue?vue&type=style&index=0&id=389bc700&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389bc700",
  null
  
)

export default component.exports